import { Content } from '@databases/types/confluence';

import { DATABASE_TITLE_SUFFIX } from '../constants';

/**
 * Returns the database name that a certain custom content title represents. The custom
 * content title is the database name with a suffix, see {@link DATABASE_TITLE_SUFFIX}.
 */
export function getDatabaseNameForContent(content: Content): string {
  if (content.title.endsWith(DATABASE_TITLE_SUFFIX)) {
    return content.title.substr(0, content.title.length - DATABASE_TITLE_SUFFIX.length);
  } else {
    return content.title;
  }
}

export interface DatabaseError extends Error {
  /**
   * Indicates that a database entries CCEO, rather than a database CCEO was tried to be converted to a database.
   * The property will contain the content ID of the corresponding database CCEO.
   */
  _orderlyDatabaseContentId?: string;
}
